import SearchPage from './search/index.page';

export default SearchPage;
